const translations = {
  "en": {
    "View all": "View all"
  },
  "zh-tw": {
    "View all": "查看全部"
  }
};

export default translations;
